module.exports = __webpack_public_path__ + "media/assets/images/logo_floen-c15758c26ea91c93b7f86b5d180ecb7b.svg";